export default __webpack_public_path__ + "static/tag-do-3-dark-f6430ae23e17a2c302341ee6096572f6.png";